import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_gourmet_chocolate: FaireThemeEntity = {
  token: "discovery_theme_gourmet-chocolate",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Gourmet Chocolate & Sweets",
  description: "Indulgent treats from top chocolatiers",
  bgColor: "#E0D4C0",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
